import { t } from "@/i18n-js/instance";
import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import { CustomizeHomeForm } from "../CustomizeHomeForm";
import { HomeDropdownOptions } from "../HomeDropdownOptions";
import { useManageFeedActionsV3 } from "./useManageFeedActionsV3";

export const ManageFeedActionsV3 = () => {
  const {
    coverImage,
    shouldShowCustomizeHome,
    shouldShowCoverImageModal,
    shouldShowCustomizeModal,
    isCoverImageLoading,
    displayWelcomeBanner: shouldDisplayWelcomeBanner,
    initialSectionRef,
    toggleCoverImageModal,
    toggleCustomizeModal,
    toggleCustomizeModalWithSection,
    onAddCoverImage,
    isDataRefreshing,
  } = useManageFeedActionsV3();

  if (!shouldShowCustomizeHome) {
    return null;
  }

  return (
    <>
      <ThreeDotsDropdownV3
        label={t("feed_settings")}
        dataTestId="feed-settings"
      >
        <HomeDropdownOptions
          displayWelcomeBanner={shouldDisplayWelcomeBanner}
          toggleCoverImageModal={toggleCoverImageModal}
          toggleCustomizeModalWithSection={toggleCustomizeModalWithSection}
          isCoverImageVisible={!!coverImage}
        />
      </ThreeDotsDropdownV3>
      <CustomizeHomeForm
        coverImage={coverImage}
        shouldShowCoverImageModal={shouldShowCoverImageModal}
        toggleCoverImageModal={toggleCoverImageModal}
        shouldShowCustomizeModal={shouldShowCustomizeModal}
        toggleCustomizeModal={toggleCustomizeModal}
        isCoverImageLoading={isCoverImageLoading}
        onAddCoverImage={onAddCoverImage}
        isDataRefreshing={isDataRefreshing}
        initialSection={initialSectionRef.current}
      />
    </>
  );
};
